import { withNotifications } from "@fas/ui-framework";
import { Notifications } from "@fas/ui-core";

export default withNotifications(Notifications);
